﻿import {RefObject, useCallback} from "react";

export function useArrayOnChange<T extends HTMLElement>(ref: RefObject<T | null>, onChange: (values: number[]) => void): () => void;
export function useArrayOnChange<T extends HTMLElement>(ref: RefObject<T | null>, onChange?: undefined): undefined;
export function useArrayOnChange<T extends HTMLElement>(ref: RefObject<T | null>, onChange: ((values: number[]) => void) | undefined): (() => void) | undefined;
export function useArrayOnChange<T extends HTMLElement>(ref: RefObject<T | null>, onChange: ((values: number[]) => void) | undefined): (() => void) | undefined {
	const callback = useCallback(function (): void {
		const parent = ref.current;
		if (!parent) {
			return;
		}

		const inputs = parent.querySelectorAll<HTMLInputElement>("input[data-array-key]");
		const selected: number[] = [];
		for (let i = 0, l = inputs.length; i < l; ++i) {
			const input = inputs[i];
			if (!input.checked) {
				continue;
			}
			const key = Number(input.dataset["arrayKey"]);
			if (Number.isNaN(key)) {
				continue;
			}
			selected.push(key);
		}

		onChange!(selected);
	}, [onChange]);

	return onChange ? callback : undefined;
}
